// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"329":"48ab4688","382":"4fa1fca9"}[chunkId] + ".chunk.js";
};